import { useCurrentBuildVersion } from "@/hooks/use-current-build-version";
import useSWR from "swr";
import { getFromServerFallback, getLookup } from "./geojson.helpers";

const LOOKUP_CACHE_KEY = "CONNECTIONS_LOOKUP";

export function useLookup() {
  const { data: version } = useCurrentBuildVersion()
  return useSWR(
    version === undefined ? null : [LOOKUP_CACHE_KEY, version],
    async () => {
      if (!version) {
        console.warn("useLookup: No version provided, falling back to default lookup.");
        return getFromServerFallback();
      }
 
      return getLookup(version ?? undefined);
    },
    {
      refreshWhenHidden: false,
      refreshWhenOffline: false,
      keepPreviousData: true,
      revalidateOnFocus: false,
      revalidateIfStale: false,
      revalidateOnReconnect: false,
    }
  );
}